import React from 'react'
import { css, cx } from '@emotion/css'
import { Cell } from './legacy-grid-cell'
import { TableRow } from './legacy-grid-table-row'
import { LegacyGridColumn } from './index'

export interface ParentRowData {
  readonly id: string
  readonly name: string
}

export interface BaseRowData {
  readonly id: string
  readonly parent?: ParentRowData
}

export const tableRowDataTestID = 'legacy-grid-table-row'

interface TableRowsProps<TLegacyRowData> {
  readonly rowsData: TLegacyRowData[]
  readonly rowClassName?: string
  readonly columnConfigs: Array<LegacyGridColumn<TLegacyRowData>>
  readonly areRowsInParent?: boolean
}

export function TableRows<TLegacyRowData extends BaseRowData>({
  rowsData,
  rowClassName,
  columnConfigs,
  areRowsInParent = false
}: TableRowsProps<TLegacyRowData>) {
  return (
    <>
      {rowsData.map((currRowData, currRowIndex) => {
        const isLastRow = currRowIndex === rowsData.length - 1

        return (
          <TableRow
            key={currRowIndex}
            dataTestID={tableRowDataTestID}
            className={rowClassName}
            isLastRow={isLastRow}
          >
            {columnConfigs.map(
              ({ CellContent, styles, horizontalCenter }, columnIndex) => {
                const isLastColumn = columnIndex === columnConfigs.length - 1

                const extraStyles = !!styles
                  ? cx(
                      !!styles.width &&
                        css`
                          width: ${styles.width};
                        `,
                      !!styles.maxWidth &&
                        css`
                          max-width: ${styles.maxWidth};
                        `,
                      !!styles.padding &&
                        css`
                          padding: ${styles.padding};
                        `,
                      !!styles.verticalAlign &&
                        css`
                          vertical-align: ${styles.verticalAlign};
                        `
                    )
                  : undefined

                return (
                  <Cell
                    key={columnIndex}
                    Component="td"
                    isLastColumn={isLastColumn}
                    className={cx(
                      css`
                        padding: 10px 10px 10px 8px;
                        ${horizontalCenter && 'text-align: center'};
                      `,
                      extraStyles
                    )}
                  >
                    <CellContent
                      rowData={currRowData}
                      hasParent={areRowsInParent}
                    />
                  </Cell>
                )
              }
            )}
          </TableRow>
        )
      })}
    </>
  )
}
